interface ExchangeProps {
  className?: string
}

const Exchange: React.FC<ExchangeProps> = ({ className }) => (
  <svg
    width="16"
    height="18"
    viewBox="0 0 16 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    focusable="false"
    aria-hidden="true"
    className={className ?? ""}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.70711 1.29289L4 0.585785L3.29289 1.29289L0.292893 4.29289C-0.0976311 4.68342 -0.0976311 5.31658 0.292893 5.70711C0.683418 6.09763 1.31658 6.09763 1.70711 5.70711L3 4.41421L3 14C3 14.5523 3.44772 15 4 15C4.55229 15 5 14.5523 5 14L5 4.41421L6.29289 5.7071C6.68342 6.09763 7.31658 6.09763 7.70711 5.7071C8.09763 5.31658 8.09763 4.68341 7.70711 4.29289L4.70711 1.29289ZM11.2929 16.7071L12 17.4142L12.7071 16.7071L15.7071 13.7071C16.0976 13.3166 16.0976 12.6834 15.7071 12.2929C15.3166 11.9024 14.6834 11.9024 14.2929 12.2929L13 13.5858L13 4C13 3.44771 12.5523 3 12 3C11.4477 3 11 3.44771 11 4L11 13.5858L9.70711 12.2929C9.31658 11.9024 8.68342 11.9024 8.29289 12.2929C7.90237 12.6834 7.90237 13.3166 8.29289 13.7071L11.2929 16.7071Z"
      fill="currentColor"
    ></path>
  </svg>
)

export default Exchange
